module.exports = __webpack_public_path__ + "img/browse-vehicles-background-toyota.e970ca7b.png";